"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = function _default(mathjax) {
  return Promise.resolve(window.MathJax || (mathjax === false ? undefined : import( /* webpackChunkName: "mathjax" */'../mathjax').then(function () {
    return window.MathJax;
  })));
};
exports.default = _default;